






import { Component, Vue } from 'vue-property-decorator'

@Component
export default class App extends Vue {
	private dirty: boolean = false
	private unsubs: Array<() => void> = []

	mounted() {
		// Install conditional beforeunload handler
		window.addEventListener('beforeunload', this.onBeforeUnload)

		const unsubMut = this.$store.subscribe(mutation => {
			mutation.type && (this.dirty = true)
		})

		// Mark initialized when platforms have been loaded for the current product
		const unsubAct = this.$store.subscribeAction({
			after: action => {
				if (action.type === 'platforms/LOAD') {
					this.dirty = false
				}
			}
		})
		window.addEventListener('beforeunload', (e = window.event) => {
			if (this.$route.fullPath !== '/login' && this.dirty) {
				if (e) {
					e.returnValue = 'Sure?'
				}
			}
		})

		this.unsubs.push(unsubMut)
	}

	beforeDestroy() {
		window.removeEventListener('beforeunload', this.onBeforeUnload)
		this.unsubs.forEach(unsubscribe => unsubscribe?.())
		this.unsubs = []
	}
}
